// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.Footer_footer-real__TTZ6Y {
  background: #333333;
  color: #9d9d99;
  box-shadow: 0 2px 10px 0 rgba(16, 16, 16, 0.5);
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/components/Page/Footer.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AChCA;EACI,mBDSW;ECRX,cDYqB;ECXrB,8CAAA;EAEA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAMJ","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.footer-real {\n  background: #333333;\n  color: #9d9d99;\n  box-shadow: 0 2px 10px 0 rgba(16, 16, 16, 0.5);\n  padding-left: 2rem;\n  padding-right: 2rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-real": `Footer_footer-real__TTZ6Y`
};
export default ___CSS_LOADER_EXPORT___;
